export const products = [
  {
    id: 1,
    name: 'Laminam Calacatta Oro',
    category: 'კერამიკა',
    brand: 'Laminam',
    price: 285,
    image: 'https://readdy.ai/api/search-image?query=Calacatta%20Oro%20marble%20look%20large%20format%20ceramic%20tile%20elegant%20white%20with%20gold%20veins%20luxury%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-1&orientation=portrait',
    description: 'ულტრა-თხელი დიდი ფორმატის კერამიკული ფილა Calacatta Oro მარმარილოს ეფექტით. 3მმ სისქე, 1000x3000მმ ზომა.',
    longDescription: 'Laminam Calacatta Oro წარმოადგენს იტალიური კერამიკული ინდუსტრიის მწვერვალს. ფილა ზუსტად ასახავს Calacatta Oro მარმარილოს ბუნებრივ ოქროსფერ ძარღვებს. პროდუქტი სრულად შეესაბამება ევროპულ სტანდარტებს (EN 14411) და ფლობს ISO 9001 სერთიფიკატს.',
    features: ['ულტრა-თხელი 3მმ სისქე', 'UV და სითბოს გამძლე', 'ჰიგიენური ზედაპირი', 'ადვილად სუფთავდება', 'ეკოლოგიურად სუფთა', 'ISO 9001 სერთიფიკატი'],
    installation: 'მონტაჟი შესაძლებელია ნებისმიერ ზედაპირზე პირდაპირ, სპეციალური Laminam-ის წებოს გამოყენებით. ჭრა ხდება ბრილიანტის დისკით.',
    tag: 'ბესტსელერი',
    material: 'კერამიკა',
    size: '1000x3000mm',
    thickness: '3mm',
    origin: 'იტალია',
  },
  {
    id: 2,
    name: 'Laminam Statuario Venato',
    category: 'კერამიკა',
    brand: 'Laminam',
    price: 310,
    image: 'https://readdy.ai/api/search-image?query=Statuario%20Venato%20white%20marble%20look%20large%20format%20ceramic%20tile%20elegant%20grey%20veins%20luxury%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-2&orientation=portrait',
    description: 'Statuario Venato კლასიკური მარმარილოს ეფექტით. 5მმ სისქე, 1620x3240მმ ზომა.',
    longDescription: 'Laminam Statuario Venato — კლასიკური იტალიური სტილის განსახიერება. ფილა ზუსტად ასახავს Statuario Venato მარმარილოს ნაცრისფერ ძარღვებს თეთრ ფონზე. 5მმ სისქე ამ ფილას განსაკუთრებულ სიმტკიცეს ანიჭებს.',
    features: ['5მმ გაძლიერებული სისქე', 'ქიმიური გამძლეობა', 'კომერციული გამოყენება', 'მინიმალური ფუგები', 'ანტი-ბაქტერიული ზედაპირი', 'EN 14411 სტანდარტი'],
    installation: 'მსხვილი ფორმატის გამო მონტაჟი საჭიროებს გამოცდილ ოსტატს. გამოიყენეთ Laminam-ის სპეციალური ეპოქსიდური წებო.',
    tag: 'პრემიუმ',
    material: 'კერამიკა',
    size: '1620x3240mm',
    thickness: '5mm',
    origin: 'იტალია',
  },
  {
    id: 3,
    name: 'Laminam Noir Desir',
    category: 'კერამიკა',
    brand: 'Laminam',
    price: 265,
    image: 'https://readdy.ai/api/search-image?query=Noir%20Desir%20black%20marble%20look%20large%20format%20ceramic%20tile%20elegant%20white%20veins%20luxury%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-3&orientation=portrait',
    description: 'Noir Desir შავი მარმარილოს ეფექტით. 3მმ სისქე, 1000x3000მმ ზომა.',
    longDescription: 'Laminam Noir Desir — სიბნელის პოეზია. ფილა ასახავს შავი მარმარილოს ბუნებრივი სილამაზის ძარღვებს. ხელმისაწვდომია პოლირებულ და მატ ვარიანტებში.',
    features: ['დრამატული შავი ფინიში', 'პოლირებული და მატი ვარიანტი', 'სივრცის ვიზუალური გაფართოება', 'UV გამძლე', 'ადვილი მოვლა', 'კომერციული კლასი'],
    installation: 'Noir Desir-ის მონტაჟი იდენტურია სხვა Laminam ფილებისა. შავ ფილებთან რეკომენდებულია მუქი ფუგა.',
    tag: 'ახალი',
    material: 'კერამიკა',
    size: '1000x3000mm',
    thickness: '3mm',
    origin: 'იტალია',
  },
  {
    id: 4,
    name: 'Laminam Pietra di Savoia',
    category: 'კერამიკა',
    brand: 'Laminam',
    price: 240,
    image: 'https://readdy.ai/api/search-image?query=Pietra%20di%20Savoia%20stone%20look%20large%20format%20ceramic%20tile%20elegant%20beige%20texture%20luxury%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-4&orientation=portrait',
    description: 'Pietra di Savoia ბუნებრივი ქვის ეფექტით. 5მმ სისქე, 1620x3240მმ ზომა.',
    longDescription: 'Laminam Pietra di Savoia შთაგონებულია საბუა-ს ალპური ქვის ბუნებრივი ტექსტურით. ბეჟ-ნაცრისფერი ტონები და ბუნებრივი ქვის ტექსტურა ამ ფილის ვერსატილური არჩევანს ხდის.',
    features: ['ბუნებრივი ქვის ეფექტი', 'თბილი ბეჟ-ნაცრისფერი ტონები', 'ვერსატილური გამოყენება', 'სპა და სასტუმრო კლასი', 'ანტი-სრიალი ვარიანტი', 'ყინვაგამძლე'],
    installation: 'Pietra di Savoia-ს ანტი-სრიალი ვარიანტი განსაკუთრებით რეკომენდებულია სველ სივრცეებში.',
    tag: null,
    material: 'კერამიკა',
    size: '1620x3240mm',
    thickness: '5mm',
    origin: 'იტალია',
  },
  {
    id: 5,
    name: 'Fodbo Oak Classic',
    category: 'იატაკი',
    brand: 'Fodbo',
    price: 95,
    image: 'https://readdy.ai/api/search-image?query=Oak%20Classic%20laminate%20flooring%20warm%20natural%20wood%20texture%20elegant%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-5&orientation=portrait',
    description: 'Fodbo Oak Classic ლამინირებული პარკეტი ბუნებრივი მუხის ეფექტით. 8მმ სისქე, AC4 კლასი.',
    longDescription: 'Fodbo Oak Classic — დანიური ხარისხის ხელმისაწვდომი ფასად. AC4 კლასი ნიშნავს, რომ ეს პარკეტი შეფასებულია ინტენსიური კომერციული გამოყენებისთვის.',
    features: ['AC4 კომერციული კლასი', 'Click-Lock სისტემა', 'ხმის შთანთქმა 19dB', 'ტენის გამძლე', 'ბუნებრივი მუხის ეფექტი', '25 წლის გარანტია'],
    installation: 'Fodbo Oak Classic მონტაჟდება მცურავი მეთოდით — წებოს გარეშე. კედლებთან 10-15მმ გაფართოების ხარვეზი სავალდებულოა.',
    tag: 'ბესტსელერი',
    material: 'ლამინატი',
    size: '1380x193mm',
    thickness: '8mm',
    origin: 'დანია',
  },
  {
    id: 6,
    name: 'Fodbo Walnut Premium',
    category: 'იატაკი',
    brand: 'Fodbo',
    price: 120,
    image: 'https://readdy.ai/api/search-image?query=Walnut%20Premium%20laminate%20flooring%20dark%20rich%20wood%20texture%20elegant%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-6&orientation=portrait',
    description: 'Fodbo Walnut Premium ლამინირებული პარკეტი კაკლის ეფექტით. 12მმ სისქე, AC5 კლასი.',
    longDescription: 'Fodbo Walnut Premium — ფუფუნება ფეხქვეშ. AC5 კლასი — ყველაზე მაღალი კლასი ლამინირებული პარკეტისთვის. 12მმ სისქე უზრუნველყოფს განსაკუთრებულ კომფორტს.',
    features: ['AC5 ყველაზე მაღალი კლასი', '12მმ პრემიუმ სისქე', 'ჩაშენებული ხმის იზოლაცია 21dB', '4V-ჭრილი ბუნებრივი ეფექტი', 'ანტი-სტატიკური', '30 წლის გარანტია'],
    installation: 'Walnut Premium-ს გააჩნია ჩაშენებული ხმის საიზოლაციო ფენა. Click-Lock სისტემა. კედლებთან 12-15მმ ხარვეზი.',
    tag: 'პრემიუმ',
    material: 'ლამინატი',
    size: '1380x193mm',
    thickness: '12mm',
    origin: 'დანია',
  },
  {
    id: 7,
    name: 'Dicson SPC Stone Oak',
    category: 'იატაკი',
    brand: 'Dicson',
    price: 75,
    image: 'https://readdy.ai/api/search-image?query=SPC%20Stone%20Oak%20vinyl%20flooring%20stone%20wood%20hybrid%20texture%20elegant%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-7&orientation=portrait',
    description: 'Dicson SPC Stone Oak SPC ფილა ქვა-ხის ჰიბრიდული ეფექტით. 4მმ სისქე, წყალგაუმტარი.',
    longDescription: 'Dicson SPC Stone Oak — ინოვაციური SPC ტექნოლოგია, რომელიც აერთიანებს ქვის სიმტკიცეს და ხის სილამაზეს. 100% წყალგაუმტარია.',
    features: ['100% წყალგაუმტარი', 'SPC ქვა-პლასტიკის ბირთვი', 'ქვეშ გათბობასთან თავსებადი', 'ანტი-სრიალი ზედაპირი', 'ადვილი მონტაჟი', 'ბაქტერიების საწინააღმდეგო'],
    installation: 'SPC ფილები მონტაჟდება Click-Lock სისტემით წებოს გარეშე. კედლებთან 5-8მმ ხარვეზი.',
    tag: 'ახალი',
    material: 'SPC',
    size: '1220x180mm',
    thickness: '4mm',
    origin: 'გერმანია',
  },
  {
    id: 8,
    name: 'Dicson LVT Marble White',
    category: 'იატაკი',
    brand: 'Dicson',
    price: 68,
    image: 'https://readdy.ai/api/search-image?query=LVT%20Marble%20White%20vinyl%20flooring%20marble%20look%20elegant%20white%20texture%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-8&orientation=portrait',
    description: 'Dicson LVT Marble White LVT ფილა მარმარილოს ეფექტით. 2.5მმ სისქე, თვითწებვადი.',
    longDescription: 'Dicson LVT Marble White — ბუნებრივი მარმარილოს ეფექტი ხელმისაწვდომი ფასად. თვითწებვადი სისტემა მონტაჟს ადვილს ხდის.',
    features: ['თვითწებვადი სისტემა', 'LVT პრემიუმ ვინილი', 'მარმარილოს ეფექტი', 'წყალგაუმტარი', 'ადვილი მონტაჟი', 'ადვილი შეცვლა'],
    installation: 'ზედაპირი უნდა იყოს სუფთა, მშრალი. მოხსენით დამცავი ფენა და მიაწებეთ.',
    tag: null,
    material: 'LVT',
    size: '610x305mm',
    thickness: '2.5mm',
    origin: 'გერმანია',
  },
  {
    id: 9,
    name: 'Ardex P 51 Primer',
    category: 'სამშენებლო ქიმია',
    brand: 'Ardex',
    price: 45,
    image: 'https://readdy.ai/api/search-image?query=Professional%20construction%20primer%20product%20can%20Ardex%20brand%20elegant%20product%20photography%20warm%20lighting%20minimal%20background&width=500&height=600&seq=phoenix-prod-9&orientation=portrait',
    description: 'Ardex P 51 უნივერსალური გრუნტი ყველა ტიპის ზედაპირისთვის. 5ლ ტევადობა.',
    longDescription: 'Ardex P 51 — გერმანული ხარისხის უნივერსალური გრუნტი. ეფექტურია ყველა ტიპის ზედაპირზე — ბეტონზე, ცემენტის ფილაზე, გიფსოკარდონზე.',
    features: ['უნივერსალური გამოყენება', 'ღრმა შეღწევა', 'შეჭიდების გაძლიერება', 'შეწოვის შემცირება', 'ელასტიური ფენა', 'სწრაფი გამოშრობა 30 წთ'],
    installation: 'გამოიყენეთ ფუნჯით, როლიკით ან სპრეით. განზავება: 1:3 წყლით. გამოშრობა: 30-60 წუთი.',
    tag: 'პროფესიული',
    material: 'გრუნტი',
    size: '5L',
    thickness: null,
    origin: 'გერმანია',
  },
  {
    id: 10,
    name: 'Ardex K 80 Flex',
    category: 'სამშენებლო ქიმია',
    brand: 'Ardex',
    price: 32,
    image: 'https://readdy.ai/api/search-image?query=Professional%20construction%20adhesive%20grout%20bag%20Ardex%20brand%20elegant%20product%20photography%20warm%20lighting%20minimal%20background&width=500&height=600&seq=phoenix-prod-10&orientation=portrait',
    description: 'Ardex K 80 Flex მაღალი ელასტიურობის წებო დიდი ფორმატის ფილებისთვის. 25კგ.',
    longDescription: 'Ardex K 80 Flex — სპეციალურად შემუშავებული დიდი ფორმატის ფილებისთვის. C2TE S1 კლასიფიკაცია. 30 წუთის ღია დრო.',
    features: ['C2TE S1 კლასიფიკაცია', 'დიდი ფორმატის ფილებისთვის', '30 წთ ღია დრო', 'ელასტიური ფენა', 'ვიბრაციის გამძლე', 'ქვეშ გათბობასთან თავსებადი'],
    installation: 'განზავება: 4.5-5ლ წყალი 25კგ-ზე. გამოიყენეთ კბილანა სპატულით. ფუგა 24 საათის შემდეგ.',
    tag: 'ბესტსელერი',
    material: 'წებო',
    size: '25kg',
    thickness: null,
    origin: 'გერმანია',
  },
  {
    id: 11,
    name: 'Ardex WPM 300',
    category: 'სამშენებლო ქიმია',
    brand: 'Ardex',
    price: 85,
    image: 'https://readdy.ai/api/search-image?query=Professional%20waterproofing%20membrane%20product%20Ardex%20brand%20elegant%20product%20photography%20warm%20lighting%20minimal%20background&width=500&height=600&seq=phoenix-prod-11&orientation=portrait',
    description: 'Ardex WPM 300 თხევადი ჰიდროიზოლაციის მემბრანა. 20კგ, 2-კომპონენტიანი.',
    longDescription: 'Ardex WPM 300 — პროფესიული 2-კომპონენტიანი ჰიდროიზოლაციის მემბრანა. EN 14891 სტანდარტი. ეკოლოგიურად სუფთა.',
    features: ['2-კომპონენტიანი სისტემა', 'EN 14891 სტანდარტი', 'ბზარებადმი გამძლე 2მმ', 'სასმელი წყლის ავზებისთვის', 'ელასტიური მემბრანა', 'UV გამძლე'],
    installation: 'შეურიეთ A და B კომპონენტები. გამოიყენეთ 2 ფენად. სრული გამოშრობა 24 საათი.',
    tag: 'პროფესიული',
    material: 'ჰიდროიზოლაცია',
    size: '20kg',
    thickness: null,
    origin: 'გერმანია',
  },
  {
    id: 12,
    name: 'Tecnopol PU 2000',
    category: 'სამშენებლო ქიმია',
    brand: 'Tecnopol',
    price: 145,
    image: 'https://readdy.ai/api/search-image?query=Polished%20epoxy%20resin%20floor%20coating%20glossy%20finish%20industrial%20modern%20interior%20warm%20lighting%20professional%20photography&width=500&height=600&seq=phoenix-prod-12&orientation=portrait',
    description: 'Tecnopol PU 2000 პოლიურეთანის ფრიალი იატაკის სისტემა. 2-კომპონენტიანი.',
    longDescription: 'Tecnopol PU 2000 — ესპანური ინჟინერიის შედევრი. პოლიურეთანის სისტემა ქმნის სრულად უწყვეტ ზედაპირს. 50-ზე მეტ ფერში ხელმისაწვდომი.',
    features: ['სრულად უწყვეტი ზედაპირი', '50+ ფერის ვარიანტი', 'ქიმიური გამძლეობა', 'ანტი-სრიალი ვარიანტი', 'სამრეწველო კლასი', 'ადვილი სუფთავდება'],
    installation: 'A და B კომპონენტები შეურიეთ 3:1 თანაფარდობით. სისქე: 2-3მმ. გამოშრობა: 24 საათი.',
    tag: 'პრემიუმ',
    material: 'პოლიურეთანი',
    size: '20kg',
    thickness: '2-3mm',
    origin: 'ესპანეთი',
  },
  {
    id: 13,
    name: 'Tecnopol EPOX 500',
    category: 'სამშენებლო ქიმია',
    brand: 'Tecnopol',
    price: 165,
    image: 'https://readdy.ai/api/search-image?query=Metallic%20epoxy%20floor%20coating%20silver%20grey%20glossy%20finish%20modern%20interior%20warm%20lighting%20professional%20photography&width=500&height=600&seq=phoenix-prod-13&orientation=portrait',
    description: 'Tecnopol EPOX 500 ეპოქსიდური ფრიალი იატაკის სისტემა მეტალიკური ეფექტით.',
    longDescription: 'Tecnopol EPOX 500 — ეპოქსიდური ფრიალი იატაკის სისტემა მეტალიკური ეფექტით. 3-კომპონენტიანი სისტემა სიღრმისეულ ეფექტს ქმნის.',
    features: ['მეტალიკური ეფექტი', '3-კომპონენტიანი სისტემა', 'ქიმიური გამძლეობა', 'ბენზინ/ზეთ გამძლე', 'სიღრმისეული ეფექტი', 'ექსკლუზიური დიზაინი'],
    installation: 'ბეტონი: ტენიანობა 4%-ზე ნაკლები. სრული სისქე: 2-4მმ. სრული გამოშრობა: 7 დღე.',
    tag: 'ახალი',
    material: 'ეპოქსიდი',
    size: '15kg',
    thickness: '2-4mm',
    origin: 'ესპანეთი',
  },
  {
    id: 14,
    name: 'Armstrong Ultima+',
    category: 'ჭერი',
    brand: 'Armstrong',
    price: 55,
    image: 'https://readdy.ai/api/search-image?query=Modern%20suspended%20ceiling%20acoustic%20panels%20white%20elegant%20office%20interior%20warm%20lighting%20professional%20photography&width=500&height=600&seq=phoenix-prod-14&orientation=portrait',
    description: 'Armstrong Ultima+ აკუსტიკური ჭერის პანელი. 600x600მმ, 15მმ სისქე, Class A ხმის შთანთქმა.',
    longDescription: 'Armstrong Ultima+ — ევროპის ყველაზე გაყიდვადი აკუსტიკური ჭერის პანელი. Class A ხმის შთანთქმა. Class A1 ხანძარსაწინააღმდეგო.',
    features: ['Class A ხმის შთანთქმა', 'Class A1 ხანძარსაწინააღმდეგო', 'სითბოს იზოლაცია', 'ადვილი მონტაჟი', 'T-ბარ სისტემასთან თავსებადი', 'ადვილი შეცვლა'],
    installation: 'Armstrong Ultima+ მონტაჟდება სტანდარტული T-ბარ სისტემაში. T-ბარი: 600x600მმ ბადე.',
    tag: 'ბესტსელერი',
    material: 'მინერალური ბამბა',
    size: '600x600mm',
    thickness: '15mm',
    origin: 'გერმანია',
  },
  {
    id: 15,
    name: 'Knauf Cleaneo Linear',
    category: 'ჭერი',
    brand: 'Knauf',
    price: 42,
    image: 'https://readdy.ai/api/search-image?query=Linear%20perforated%20acoustic%20ceiling%20panel%20modern%20office%20interior%20warm%20lighting%20professional%20photography&width=500&height=600&seq=phoenix-prod-15&orientation=portrait',
    description: 'Knauf Cleaneo Linear პერფორირებული აკუსტიკური ჭერის პანელი. 1200x600მმ, 12.5მმ სისქე.',
    longDescription: 'Knauf Cleaneo Linear — გიფსოკარდონის პერფორირებული ჭერის პანელი. ხაზოვანი პერფორაცია თანამედროვე ეფექტს ქმნის.',
    features: ['ხაზოვანი პერფორაცია', 'გიფსოკარდონის ბირთვი', 'ადვილად საღებავი', 'ხმის შთანთქმა', 'ესთეტიური დიზაინი', 'ინტეგრირებული განათება'],
    installation: 'Cleaneo Linear მონტაჟდება Knauf-ის სპეციალური ლითონის კარკასზე. CD 60 პროფილი 400მმ ბიჯით.',
    tag: null,
    material: 'გიფსოკარდონი',
    size: '1200x600mm',
    thickness: '12.5mm',
    origin: 'გერმანია',
  },
  {
    id: 16,
    name: 'Laminam Facade Rosso',
    category: 'ფასადი',
    brand: 'Laminam',
    price: 320,
    image: 'https://readdy.ai/api/search-image?query=Red%20facade%20cladding%20panel%20large%20format%20ceramic%20exterior%20building%20modern%20architecture%20warm%20lighting%20professional%20photography&width=500&height=600&seq=phoenix-prod-16&orientation=portrait',
    description: 'Laminam Facade Rosso გარე ფასადის პანელი. 1000x3000მმ, 5.6მმ სისქე.',
    longDescription: 'Laminam Facade Rosso — გარე ფასადის სისტემა. ყინვაგამძლე -40°C-დან +80°C-მდე. ვენტილირებადი ფასადის სისტემა.',
    features: ['გარე გამოყენება', 'ყინვაგამძლე -40°C', 'UV გამძლე', 'ვენტილირებადი ფასადი', 'ენერგოეფექტური', 'ხანძარსაწინააღმდეგო A1'],
    installation: 'ლითონის ქვეკარკასი კედელზე, ჰაერის ხარვეზი 40-60მმ, Laminam ფილები სპეციალური კლიპებით.',
    tag: 'პრემიუმ',
    material: 'კერამიკა',
    size: '1000x3000mm',
    thickness: '5.6mm',
    origin: 'იტალია',
  },
  {
    id: 17,
    name: 'Tecnopol Tectoflex',
    category: 'ფასადი',
    brand: 'Tecnopol',
    price: 95,
    image: 'https://readdy.ai/api/search-image?query=Waterproof%20facade%20coating%20system%20exterior%20building%20protection%20modern%20architecture%20warm%20lighting%20professional%20photography&width=500&height=600&seq=phoenix-prod-17&orientation=portrait',
    description: 'Tecnopol Tectoflex ელასტიური ფასადის საღებავი. 25კგ, წყალგაუმტარი, UV-გამძლე.',
    longDescription: 'Tecnopol Tectoflex — ელასტიური ფასადის საღებავი. 200-ზე მეტ ფერში ხელმისაწვდომი. UV გამძლე 15+ წელი.',
    features: ['ელასტიური ბზარებადმი გამძლე', 'ბიდირექციული ტენის გამტარობა', 'UV გამძლე 15+ წელი', '200+ ფერი NCS/RAL', 'ანტი-ბიოლოგიური', 'ადვილი გამოყენება'],
    installation: 'გრუნტი: Tecnopol Fondo Fijador. 2 ფენა ფუნჯით ან ვალიკით. სრული გამოშრობა: 24 საათი.',
    tag: null,
    material: 'საღებავი',
    size: '25kg',
    thickness: '1.5-2mm',
    origin: 'ესპანეთი',
  },
  {
    id: 18,
    name: 'Ardex A 45',
    category: 'სამშენებლო ქიმია',
    brand: 'Ardex',
    price: 28,
    image: 'https://readdy.ai/api/search-image?query=Professional%20self%20leveling%20compound%20bag%20Ardex%20brand%20elegant%20product%20photography%20warm%20lighting%20minimal%20background&width=500&height=600&seq=phoenix-prod-18&orientation=portrait',
    description: 'Ardex A 45 სწრაფად მშრალდება თვითგასწორებადი მასა. 25კგ, 2-45მმ სისქეზე.',
    longDescription: 'Ardex A 45 — სწრაფი თვითგასწორებადი მასა. 45 წუთში სიარული. 2-45მმ სისქეზე ეფექტური.',
    features: ['45 წუთში სიარული', '2-45მმ სისქე', 'ბოჭკოვანი გაძლიერება', 'ბზარებადმი გამძლე', 'ყველა საფართან თავსებადი', 'ქვეშ გათბობასთან თავსებადი'],
    installation: 'განზავება: 6-6.5ლ წყალი 25კგ-ზე. ჩაასხით ზედაპირზე. 45 წუთი — სიარული.',
    tag: 'ბესტსელერი',
    material: 'თვითგასწორებადი',
    size: '25kg',
    thickness: '2-45mm',
    origin: 'გერმანია',
  },
  {
    id: 19,
    name: 'Fodbo Oak Rustic',
    category: 'იატაკი',
    brand: 'Fodbo',
    price: 88,
    image: 'https://readdy.ai/api/search-image?query=Rustic%20oak%20laminate%20flooring%20distressed%20wood%20texture%20elegant%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-19&orientation=portrait',
    description: 'Fodbo Oak Rustic ლამინირებული პარკეტი რუსტიკული მუხის ეფექტით. 8მმ სისქე, AC4 კლასი.',
    longDescription: 'Fodbo Oak Rustic — ბუნებრივი, ორგანული ატმოსფეროს შემქმნელი ლამინირებული პარკეტი. რუსტიკული ეფექტი ბუნებრივი ხის ყველა ნიშანს ასახავს.',
    features: ['რუსტიკული ბუნებრივი ეფექტი', 'AC4 კომერციული კლასი', 'ფერის ბუნებრივი ვარიაცია', 'Click-Lock სისტემა', 'ხმის შთანთქმა', '25 წლის გარანტია'],
    installation: 'Oak Rustic მონტაჟდება მცურავი მეთოდით. კედლებთან: 10-15მმ ხარვეზი.',
    tag: null,
    material: 'ლამინატი',
    size: '1380x193mm',
    thickness: '8mm',
    origin: 'დანია',
  },
  {
    id: 20,
    name: 'Laminam Cotto D Este',
    category: 'კერამიკა',
    brand: 'Laminam',
    price: 225,
    image: 'https://readdy.ai/api/search-image?query=Cotto%20D%20Este%20terracotta%20look%20large%20format%20ceramic%20tile%20warm%20earth%20tones%20luxury%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-prod-20&orientation=portrait',
    description: 'Laminam Cotto D Este ტერაკოტას ეფექტით. 5მმ სისქე, 1620x3240მმ ზომა.',
    longDescription: 'Laminam Cotto D Este შთაგონებულია ხმელთაშუა ზღვის სტილით. ტერაკოტას თბილი, მიწიერი ტონები. შიდა და გარე გამოყენება.',
    features: ['ხმელთაშუა ზღვის სტილი', 'ტერაკოტას ეფექტი', 'ადვილი მოვლა', 'ლაქებადმი გამძლე', 'შიდა და გარე გამოყენება', 'ყინვაგამძლე ვარიანტი'],
    installation: 'Cotto D Este მონტაჟდება Laminam-ის სტანდარტული ინსტრუქციით. ჭრა: ბრილიანტის დისკი.',
    tag: 'ახალი',
    material: 'კერამიკა',
    size: '1620x3240mm',
    thickness: '5mm',
    origin: 'იტალია',
  },
];

export const categories = [
  {
    id: 'bunebrivi-qva',
    name: 'ბუნებრივი ქვა',
    count: 320,
    brands: ['Antolini'],
    icon: 'ri-landscape-line',
    externalHref: 'https://phoenix.ge/product-category/bunebrivi-qva/',
    image: 'https://phoenix.ge/wp-content/uploads/2024/06/bunebrivi-qva-მარმარილო04-400x300.png',
    subs: ['მარმარილო', 'ბუნებრივი გრანიტი', 'ბუნებრივი ტრავერტინი', 'ონიქსი', 'ბუნებრივი კვარციტი', 'ნახევრად ძვირფასი ქვა'],
  },
  {
    id: 'ceramics',
    name: 'კერამიკა',
    count: 1200,
    brands: ['Laminam'],
    icon: 'ri-layout-grid-line',
    externalHref: 'https://phoenix.ge/product-category/keramika/',
    image: 'https://phoenix.ge/wp-content/uploads/2024/06/laminami-keramikuli-slebi-08-400x300.png',
    subs: ['კერამიკული სლები ლამინამი'],
  },
  {
    id: 'flooring',
    name: 'იატაკი',
    count: 600,
    brands: ['Fodbo', 'Dicson'],
    icon: 'ri-stack-line',
    externalHref: 'https://phoenix.ge/product-category/iataki/',
    image: 'https://phoenix.ge/wp-content/uploads/2024/06/დეკორატიული-იატაკი-400x267.png',
    subs: ['მიკროცემენტი / დეკორატიული იატაკი', 'ფალშ-იატაკი', 'დეკინგი', 'პოლიმერული იატაკი'],
  },
  {
    id: 'drekadi-iataki',
    name: 'დრეკადი იატაკი',
    count: 280,
    brands: ['Gerflor'],
    icon: 'ri-layout-row-line',
    externalHref: 'https://phoenix.ge/product-category/drekadi-iataki/',
    image: 'https://phoenix.ge/wp-content/uploads/2024/06/ვინილი-400x267.png',
    subs: ['ვინილის იატაკი', 'ლინოლეუმი', 'კაუჩუკის იატაკი', 'კორპი', 'სპორტული იატაკი'],
  },
  {
    id: 'rbili-iataki',
    name: 'რბილი იატაკი',
    count: 350,
    brands: ['Forbo', 'Dickson'],
    icon: 'ri-artboard-line',
    externalHref: 'https://phoenix.ge/product-category/rbili-iataki/',
    image: 'https://phoenix.ge/wp-content/uploads/2024/06/კედლიდან-კედლამდე-400x267.png',
    subs: ['კედლიდან კედლამდე', 'რბილი იატაკის ფილა', 'რბილი იატაკის პლანკა', 'ჭუჭყამრიდი ბარიერი', 'ხალიჩები და ნოხები'],
  },
  {
    id: 'ceiling',
    name: 'ჭერი',
    count: 320,
    brands: ['Armstrong', 'Knauf'],
    icon: 'ri-home-4-line',
    externalHref: 'https://phoenix.ge/product-category/cheri/',
    image: 'https://phoenix.ge/wp-content/uploads/2024/06/ლითონის-400x267.png',
    subs: ['ლითონი', 'მინერალური ბოჭკო', 'ქვაბამბა', 'ტექსტილი', 'ხის ჭერი'],
  },
  {
    id: 'facade',
    name: 'ფასადი',
    count: 180,
    brands: ['Laminam'],
    icon: 'ri-building-line',
    externalHref: 'https://phoenix.ge/product-category/fasadi/',
    image: 'https://phoenix.ge/wp-content/uploads/2025/05/unnamed-1-1-300x300.png',
    subs: ['კლინკერი', 'კერამიკული დაფა პანელი', 'ხის ფასადი'],
  },
  {
    id: 'hidroizolatsia',
    name: 'ჰიდროიზოლაცია',
    count: 210,
    brands: ['Ardex', 'Tecnopol'],
    icon: 'ri-water-flash-line',
    externalHref: 'https://phoenix.ge/product-category/hidroizolatsia/',
    image: 'https://phoenix.ge/wp-content/uploads/2024/11/გეოტექსტილი-400x267.png',
    subs: ['გეოტექსტილი', 'პრაიმერები', 'ორთქლიზოლაცია', 'ჰიდროსაიზოლაციო მასალები'],
  },
  {
    id: 'chemicals',
    name: 'სამშენებლო ქიმია',
    count: 450,
    brands: ['Ardex', 'Tecnopol'],
    icon: 'ri-flask-line',
    externalHref: 'https://phoenix.ge/product-category/samshenebl-qimia/',
    image: 'https://phoenix.ge/wp-content/uploads/2024/11/კერამიკისა-და-ბუნებრივი-ქვის-წებო-1-400x267.png',
    subs: ['კერამიკის და ბუნებრივი ქვის წებო', 'დეკორატიული საფარები', 'კედელი, ფასადი და ბეტონის კოსმეტიკა', 'მჭიმები და იატაკის მომზადება', 'პარკეტის წებო', 'დამცავი საშუალებები და მოვლა'],
  },
];

export const brands = [
  { name: 'Laminam', origin: 'იტალია', specialty: 'კერამიკული ფილები', productCount: 1200, description: 'იტალიის წამყვანი ულტრა-თხელი დიდი ფორმატის კერამიკული ფილების მწარმოებელი. 3მმ-დან 20მმ-მდე სისქით ფილები კედლისთვის, იატაკისთვის და ფასადისთვის.', image: 'https://readdy.ai/api/search-image?query=Laminam%20ceramic%20tile%20factory%20showroom%20elegant%20marble%20slabs%20display%20warm%20lighting%20professional%20photography&width=600&height=400&seq=phoenix-brand-1&orientation=landscape' },
  { name: 'Ardex', origin: 'გერმანია', specialty: 'სამშენებლო ქიმია', productCount: 450, description: 'გერმანული პრემიუმ სამშენებლო ქიმიის ბრენდი. წებოები, შემმავსებლები, ჰიდროიზოლაცია და თვითგასწორებადი სისტემები.', image: 'https://readdy.ai/api/search-image?query=Ardex%20construction%20chemicals%20products%20display%20professional%20adhesive%20grout%20bags%20warm%20lighting%20minimal%20background&width=600&height=400&seq=phoenix-brand-2&orientation=landscape' },
  { name: 'Tecnopol', origin: 'ესპანეთი', specialty: 'ჰიდროიზოლაცია / ფრიალი იატაკი', productCount: 380, description: 'ესპანური ჰიდროიზოლაციისა და ფრიალი იატაკის სისტემების სპეციალისტი. ეპოქსიდური და პოლიურეთანის გადაწყვეტილებები.', image: 'https://readdy.ai/api/search-image?query=Tecnopol%20waterproofing%20resin%20floor%20coating%20application%20modern%20industrial%20interior%20warm%20lighting%20professional%20photography&width=600&height=400&seq=phoenix-brand-3&orientation=landscape' },
  { name: 'Fodbo', origin: 'დანია', specialty: 'იატაკი', productCount: 280, description: 'დანიური ლამინირებული პარკეტისა და ინჟინერული იატაკის მწარმოებელი. ბუნებრივი მუხის ეფექტი მაღალი ხარისხით.', image: 'https://readdy.ai/api/search-image?query=Fodbo%20laminate%20flooring%20showroom%20display%20warm%20oak%20wood%20planks%20elegant%20interior%20warm%20lighting%20professional%20photography&width=600&height=400&seq=phoenix-brand-4&orientation=landscape' },
  { name: 'Dicson', origin: 'გერმანია', specialty: 'იატაკი', productCount: 220, description: 'გერმანული SPC და LVT ფილების მწარმოებელი. წყალგაუმტარი, მარტივად მონტაჟდება, იდეალურია საცხოვრებელი და კომერციული სივრცეებისთვის.', image: 'https://readdy.ai/api/search-image?query=Dicson%20SPC%20vinyl%20flooring%20display%20modern%20showroom%20elegant%20interior%20warm%20lighting%20professional%20photography&width=600&height=400&seq=phoenix-brand-5&orientation=landscape' },
  { name: 'Armstrong', origin: 'გერმანია', specialty: 'ჭერი', productCount: 180, description: 'გერმანული აკუსტიკური ჭერის სისტემების ლიდერი. მინერალური ბამბის პანელები, გაჭიმული ჭერის სისტემები.', image: 'https://readdy.ai/api/search-image?query=Armstrong%20acoustic%20ceiling%20panels%20office%20interior%20modern%20design%20warm%20lighting%20professional%20photography&width=600&height=400&seq=phoenix-brand-6&orientation=landscape' },
  { name: 'Knauf', origin: 'გერმანია', specialty: 'ჭერი', productCount: 140, description: 'გერმანული გიფსოკარდონისა და აკუსტიკური სისტემების მწარმოებელი. პერფორირებული ჭერის პანელები და სამშენებლო სისტემები.', image: 'https://readdy.ai/api/search-image?query=Knauf%20gypsum%20ceiling%20panels%20construction%20materials%20display%20warm%20lighting%20professional%20photography&width=600&height=400&seq=phoenix-brand-7&orientation=landscape' },
  { name: 'Antolini', origin: 'იტალია', specialty: 'ბუნებრივი ქვა', productCount: 250, description: 'იტალიური პრემიუმ ბუნებრივი ქვის მიმწოდებელი. მარმარილო, გრანიტი, ტრავერტინი, ონიქსი და კვარციტი.', image: 'https://readdy.ai/api/search-image?query=Antolini%20natural%20stone%20marble%20slabs%20showroom%20elegant%20luxury%20interior%20warm%20lighting%20professional%20photography&width=600&height=400&seq=phoenix-brand-8&orientation=landscape' },
  { name: 'Gerflor', origin: 'საფრანგეთი', specialty: 'დრეკადი იატაკი', productCount: 190, description: 'ფრანგული სპორტული და კომერციული ვინილის იატაკის მწარმოებელი. სპორტული, კომერციული და საცხოვრებელი გადაწყვეტილებები.', image: 'https://readdy.ai/api/search-image?query=Gerflor%20vinyl%20sports%20flooring%20display%20modern%20showroom%20elegant%20interior%20warm%20lighting%20professional%20photography&width=600&height=400&seq=phoenix-brand-9&orientation=landscape' },
];
